import { StyleSheet } from 'react-native'
import { textStyles } from 'styles/text'
import { ThemedShared } from 'styles/themed'

export const NoResultsViewStyles = StyleSheet.create({
	container: {
		flexDirection: 'column',
	},
	
	containerImage: {
		alignItems: 'center',
		alignSelf: 'center',
	},
	image: {
		borderWidth: 1,
		width: 60,
		height: 'auto',
	},
	
	containerText: {
		padding: ThemedShared.paddingSmall.padding
	},
	text: {
		fontWeight: '600',
		zIndex: 2,
		...textStyles.textCenter
	}
});
